<h1 mat-dialog-title>{{"Durchatmen!" | translate : "label-breath-in"}}</h1>
<div mat-dialog-content>
  {{"Eine kleine technische Unstimmigkeit hat hier leider zu einer kurzen Verschnaufpause geführt.\nWir bitten um Verständnis." | translate : "paragraph-server-error"}}
</div>
<div mat-dialog-actions>
  <button mat-flat-button class="button--tertiary" (click)="close()">{{"Schließen" | translate: "action-close"}}</button>
</div>
